import React from "react";

import GCRlogo from "../../Images/logos/GCR.png";
import Carletonlogo from "../../Images/logos/Carleton.png";
import TIMlogo from "../../Images/logos/TIM.png";
import LTWlogo from "../../Images/logos/LTW.png";
import Canadalogo from "../../Images/logos/Canada.png";
import GlobalEPIClogo from "../../Images/logos/GlobalEPIC.png";
import TIMReviewlogo from "../../Images/logos/TimReview.png";
import FedDevlogo from "../../Images/logos/FedDev.png";
import InvestOttawalogo from "../../Images/logos/InvestOttawa.png";
import LTWGloballogo from "../../Images/logos/LTW-Global.png";

import LoganKatz from "../../Images/logos/LoganKatz.jpg";
import PS1925 from "../../Images/logos/ps1925.jpg";
import QueenBelt from "../../Images/logos/queenbelt.jpg";
import SalesDeskCompany from "../../Images/logos/sales-desk-company.jpg";
import SmartFunnel from "../../Images/logos/smartFunnel.jpg";
import SolarGreenClub from "../../Images/logos/solar-green-club.jpg";
import Think2Exist from "../../Images/logos/think2exist.jpg";
import BayviewYards_ from "../../Images/logos/BayviewYards_.jpg";
import Shrambhoomi from "../../Images/logos/shrambhoomi.jpg";
import Agrowave from "../../Images/logos/agrowave.jpg";
import AICTE from "../../Images/logos/AICTE.jpg";
import Bioscan from "../../Images/logos/bioscan.jpg";
import BtiGlobal from "../../Images/logos/bti-global.jpg";
import CapitalAngelNetwork from "../../Images/logos/capital-angel-network.jpg";
import CIAP from "../../Images/logos/CIAP.jpg";
import CICExcellence from "../../Images/logos/CIC-Excellence.jpg";
import ClancyBrion from "../../Images/logos/clancy-brion.jpg";
import Dars from "../../Images/logos/dars.jpg";
import EmpathyDesign from "../../Images/logos/empathy-design-labs.jpg";
import NareshJain from "../../Images/logos/NareshJain.jpg";
import KiitTbi from "../../Images/logos/KIIT-TBI.jpg";
import IncarSynergy from "../../Images/logos/IncarSynergy.jpg";
import Ideabytes from "../../Images/logos/Ideabytes.jpg";

const AffiliatesLogos = [
  {
    name: "Global Cybersecurity Resource",
    url: "https://cugcr.ca",
    logo: GCRlogo
  },
  {
    name: "Technology Innovation Management Program, Carleton University",
    url: "https://timprogram.ca",
    logo: TIMlogo
  },
  {
    name: "Carleton University",
    url: "https://carleton.ca/",
    logo: Carletonlogo
  },
  {
    name: "Canada-India Accelerator Program",
    url: "https://ciaccelerate.ca",
    logo: CIAP
  },
  {
    name: "Lead to Win",
    url: "https://leadtowin.ca",
    logo: LTWlogo
  },
  {
    name: "Government of Canada",
    url: "https://canada.ca",
    logo: Canadalogo
  },
  {
    name: "Global EPIC",
    url: "https://globalepic.org",
    logo: GlobalEPIClogo
  },
  {
    name: "FedDev Ontario",
    url: "http://www.feddevontario.gc.ca/eic/site/723.nsf/eng/home",
    logo: FedDevlogo
  },
  {
    name: "Invest Ottawa",
    url: "https://www.investottawa.ca/",
    logo: InvestOttawalogo
  },
  {
    name: "Lead to Win Global",
    url: "https://cugcr.ca",
    logo: LTWGloballogo
  },
  {
    name: "Shrambhoomi",
    url: "http://www.shrambhoomi.com/",
    logo: Shrambhoomi
  },    
  {
    name: "Cours Bayview Yards",
    url: "https://bayviewyards.org",
    logo: BayviewYards_
  },
  {
    name: "Agrowave",
    url: "http://agrowaves.in",
    logo: Agrowave
  },
  {
    name: "TIM Review",
    url: "https://timreview.ca",
    logo: TIMReviewlogo
  },
  {
    name: "All India Council for Technical Education",
    url: "https://www.aicte-india.org/",
    logo: AICTE
  },
  {
    name: "Bioscan Research",
    url: "https://bioscanresearch.com",
    logo: Bioscan,
  },
  {
    name: "BTI Global Innovation",
    url: "https://www.btiglobalinnovation.com/",
    logo: BtiGlobal
  },
  {
    name: "Capital Angel Network",
    url: "https://www.capitalangels.ca/",
    logo: CapitalAngelNetwork
  },
  {
    name: "Canada-India Centre of Excellence",
    url: "https://carleton.ca/india/",
    logo: CICExcellence,
  },
  {
    name: "Clancy and Brian Raffoul",
    url: "https://www.cbrcanada.com/",
    logo: ClancyBrion
  },
  {
    name: "Dars",
    url: "",
    logo: Dars
  },
  {
    name: "Empathy Design Labs",
    url: "http://empathydesignlabs.com",
    logo: EmpathyDesign,
  },
  {
    name: "Logan Katz",
    url: "https://logankatz.com/",
    logo: LoganKatz
  },
  {
    name: "PS1925",
    url: "http://ps-1925.com",
    logo: PS1925
  },
  {
    name: "QueenBelt",
    url: "",
    logo: QueenBelt,
  },
  {
    name: "The Sales Desk Company",
    url: "https://thesalesdeskcompany.com/",
    logo: SalesDeskCompany
  },
  {
    name: "Smart Funnel",
    url: "https://smartfunnel.com/",
    logo: SmartFunnel
  },
  {
    name: "Think2Exist",
    url: "http://think2exist.in",
    logo: Think2Exist,
  },
  {
    name: "Solar Green Club",
    url: "",
    logo: SolarGreenClub
  },
  {
    name: "Naresh Jain",
    url: "https://nareshjain.com",
    logo: NareshJain
  },
  {
    name: "KIIT Technology Business Incubator (KIIT-TBI)",
    url: "http://www.kiitincubator.in/",
    logo: KiitTbi,
  },
  {
    name: "Inca Synergies",
    url: "http://www.incasynergies.com/",
    logo: IncarSynergy
  },
  {
    name: "Ideabytes - Innovation is business",
    url: "http://www.ideabytes.com/",
    logo: Ideabytes
  },
];

export { AffiliatesLogos }



// WEBPACK FOOTER //
// ./src/Components/Partners/LogoImports.js